import axios from 'axios'
import authHeader from './AuthHeader'
import { API_URL } from '../config/api'

class PaymentsPartnersService {

    // Get projects expenses list
    getPaymentsPartners = async (pageNum, search = '', limit = false, sortBy = 'name', sortOrder = 'asc', projectId = '', partnerId = '') => {
        return await axios.get(API_URL + '/paymentsPartners?page=' + pageNum + '&search=' + search + '&limit=' + limit + '&sortBy=' + sortBy + '&sortOrder=' + sortOrder + '&projectId=' + projectId + '&partnerId=' + partnerId, { headers: authHeader() })
    }

    // Add new project expense
    addPaymentPartner = async (paymentPartner) => {
        return await axios.post(API_URL + '/paymentsPartners', paymentPartner, { headers: authHeader() })
    }

    // Update project expense data
    updatePaymentPartner = async (paymentPartner, id) => {
        return await axios.patch(API_URL + '/paymentsPartners/' + id, paymentPartner, { headers: authHeader() })
    }

    // Get project expense data
    getPaymentPartner = async (id) => {
        return await axios.get(API_URL + '/paymentsPartners/' + id, { headers: authHeader() })
    }

    // Delete project expense
    deletePaymentPartner = async (id) => {
        return await axios.delete(API_URL + '/paymentsPartners/' + id, { headers: authHeader() })
    }

    getPaymentsPartnersDataset = async ({ projectId = '', yearFrom = '', yearTo = '', partnerId = '' }) => {

        const params = new URLSearchParams()
        if (projectId) params.append("projectId", projectId)
        if (yearFrom) params.append("yearFrom", yearFrom)
        if (yearTo) params.append("yearTo", yearTo)
        if (partnerId) params.append("partnerId", partnerId)

        const url = `${API_URL}/dataset/paymentspartners?${params.toString()}`
    
        return await axios.get(url, { headers: authHeader() })
    }
}

export default new PaymentsPartnersService()